module.exports = __webpack_public_path__ + "img/inbox-alert.72f42e41.svg";